export default {
    baseStyle: () => ({
        gcInfo: {
            width: {base: '100%', md: '47.5%'}
        },
        gcForm: {
            width: {base: '100%', md: '52.5%'},
            float: {base: 'none', md: 'right'}
        },
        gc: {
            flexDirection: {base: 'column', sm: 'row', lg: 'row'}
        },
        gcFormHeading: {
            fontSize: '2xl',
            paddingLeft: {base: '1rem'}
        }
    }),
    parts: ['gcInfo', 'gcForm', 'gc']
}
